import { faClipboardListCheck } from '@fortawesome/pro-regular-svg-icons'
import Button from 'components/Button'
import { useEventContext } from 'context/EventContext'
import {
  EventState,
  EventRegistrationRSVP,
  EventFormat
} from 'graphql/generated'
import Link from 'next/link'

function ViewRecapButton() {
  const { event } = useEventContext()
  const hasEnded = event.state === EventState.ENDED
  const showRecapButton =
    hasEnded &&
    event.rsvp === EventRegistrationRSVP.YES &&
    // in-person events shouldn't show this button
    (event.format === EventFormat.MIXER ||
      event.format === EventFormat.HOLIDAY_MIXER)

  if (!showRecapButton) {
    return null
  }

  return (
    <Link href={`${event.publicUrl}/recap`} passHref>
      <Button
        icon={faClipboardListCheck}
        color={'blue'}
        size={'md'}
        label={`View Recap`}
      />
    </Link>
  )
}

export default ViewRecapButton
